<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="" v-if="!mantenimiento">
      <!-- <v-row> -->


      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">

         <v-btn
            class="mx-2"
            fab
            dark
            small
            color="success"
            @click="$router.go(-1)"
            v-if="user && user.IDStB"
          >
            <v-icon dark>
              mdi-keyboard-backspace
            </v-icon>
          </v-btn>
          <br/><br/>
          <v-alert dense outlined type="warning">
              <strong>Los pagos con la pasarela de pago Qobra pueden demorar en acreditarse unos minutos</strong>
          </v-alert>
          <v-alert v-show="isSuscribedDA" dense outlined type="warning">
              <strong>Usted está adherido al débito automático en Mercado Pago. Si el primer intento de débito falla, se volverá a intentar tres veces en los próximos días. El último intento es el día 15 de cada mes. En caso de no visualizar su pago acreditado, por favor genere una consulta en "informar un pago".</strong>
          </v-alert>
          <v-alert v-show="isSuscribedMB" dense outlined type="warning">
              <strong>Usted está adherido al débito automático en Mobbex. Si el primer intento de débito falla, se volverá a intentar tres veces en los próximos días. En caso de no visualizar su pago acreditado, por favor genere una consulta en "informar un pago".</strong>
          </v-alert>
          <div
                class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
              >{{ title }}</div>

          <v-row align="center">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">



              <v-select
                v-model="curso"
                :items="cursos"
                item-text="cruso_data.Feriado"
                item-value="cruso_data.IDF"
                label="Selecciona el curso a pagar"
                persistent-hint
                return-object
                single-line
                v-on:change="loadData"
              ></v-select>
            </v-col>
        </v-row>
         <div v-if="curso"><br/>
          <h2>
            Selecciona lo que pagarás
          </h2>
          <v-simple-table >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Valor regular
                  </th>
                  <th class="text-left">
                    Concepto
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>


                <tr v-for="(pagoData,
                  pagoKey) in pagos.items"
                  :key="pagoKey"


                  >

                  <td v-bind:style="colorText(pagoData)" v-if="canPay(pagoData)">
                    <span style="margin-right: 20px;">${{pagoData.precioAPagar}}</span>

                     <v-badge
                      :content="'Beca ' + pagoData.beca + '%'"
                      :value="messages"
                      color="green"
                      v-if="pagoData.beca != 0"
                    >
                    </v-badge>
                  </td>
                  <td v-bind:style="colorText(pagoData)" v-if="pagoData.pagado">${{pagoData.precioPagado}}</td>
                  <td v-bind:style="colorText(pagoData)" v-else-if="pagoData.block">${{pagoData.precioAPagar}}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.Materia }}</td>
                  <td>
                    <v-checkbox
                      v-if="canPay(pagoData)"
                      v-model="pagoData.check"
                      @change="changeTotal(pagoData, pagoKey)"
                    ></v-checkbox>
                  </td>

                </tr>



                <tr style="background-color: orange; color: white;">
                  <td><strong>COMISIÓN DE PLATAFORMA</strong></td>
                  <td><strong>0%</strong></td>
                  <td></td>
                </tr>

                <tr style="background-color: green; color: white;">
                  <td><strong>TOTAL</strong></td>
                  <td><strong>${{total}}</strong></td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <br/>
          <v-row align="center">
            <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="pay()"
              :disabled="total == 0"
              >Efectuar pago</v-btn
            >
            </v-col>
          </v-row>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          
          <div class="pa-6 content-area bg-light">

            <v-alert v-show="isSuscribedDA" prominent outlined type="warning" class="rounded-xl glass-card border-none mb-6">
              <strong>Usted está adherido al débito automático en Mercado Pago. Si el primer intento de débito falla, se volverá a intentar tres veces en los próximos días. El último intento es el día 15 de cada mes. En caso de no visualizar su pago acreditado, por favor genere una consulta en "informar un pago".</strong>
            </v-alert>
            <v-alert v-show="isSuscribedMB" prominent outlined type="warning" class="rounded-xl glass-card border-none mb-6">
              <strong>Usted está adherido al débito automático en Mobbex. Si el primer intento de débito falla, se volverá a intentar tres veces en los próximos días. En caso de no visualizar su pago acreditado, por favor genere una consulta en "informar un pago".</strong>
            </v-alert>

            <v-row>
              <v-col cols="12">
                <div class="text-subtitle-2 font-weight-bold mb-2">Curso</div>
                <v-select
                  v-model="curso"
                  :items="cursos"
                  item-text="cruso_data.Feriado"
                  item-value="cruso_data.IDF"
                  placeholder="Selecciona el curso a pagar"
                  outlined
                  rounded
                  dense
                  prepend-inner-icon="mdi-school"
                  return-object
                  @change="loadData"
                ></v-select>
              </v-col>
            </v-row>

            <v-expand-transition>
              <div v-if="curso && pagos.items && pagos.items.length > 0" class="mt-4">
                <div class="text-subtitle-1 font-weight-bold primary-text mb-4">
                  <v-icon color="primary" left>mdi-format-list-checks</v-icon> Selecciona lo que pagarás
                </div>
                
                <v-card class="rounded-xl border-light overflow-hidden" elevation="0">
                  <v-list class="pa-0 bg-transparent">
                    <template v-for="(pagoData, pagoKey) in pagos.items">
                      <v-list-item :key="pagoKey" class="py-3 px-4 border-bottom" :class="{'bg-light-gradient': pagoData.check}">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            v-if="canPay(pagoData)"
                            v-model="pagoData.check"
                            color="primary"
                            @change="changeTotal(pagoData, pagoKey)"
                          ></v-checkbox>
                          <v-icon v-else-if="pagoData.pagado" color="success">mdi-check-circle</v-icon>
                          <v-icon v-else color="grey">mdi-lock</v-icon>
                        </v-list-item-action>
                        
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold" :class="getTextColorClass(pagoData)">
                            {{ pagoData.Materia }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="pagoData.beca != 0" class="mt-1">
                            <v-chip small color="success lighten-5" text-color="success darken-1" class="font-weight-bold">
                              Beca {{ pagoData.beca }}%
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        
                        <v-list-item-action>
                          <div class="text-h6 font-weight-bold" :class="getTextColorClass(pagoData)">
                            <span v-if="pagoData.pagado">${{ pagoData.precioPagado }}</span>
                            <span v-else>${{ pagoData.precioAPagar }}</span>
                          </div>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider :key="'div-'+pagoKey" v-if="pagoKey < pagos.items.length - 1"></v-divider>
                    </template>
                    
                    <v-list-item class="py-3 px-4 bg-warning-light">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold warning--text text--darken-3">
                          COMISIÓN DE PLATAFORMA
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <div class="text-subtitle-1 font-weight-bold warning--text text--darken-3">0%</div>
                      </v-list-item-action>
                    </v-list-item>
                    
                    <v-list-item class="py-4 px-4 bg-success-light">
                      <v-list-item-content>
                        <v-list-item-title class="text-h6 font-weight-bold success--text text--darken-3">
                          TOTAL A PAGAR
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <div class="text-h5 font-weight-bold success--text text--darken-3">${{ total }}</div>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>

                <div class="d-flex justify-end mt-6">
                  <v-btn
                    color="primary"
                    rounded
                    depressed
                    large
                    class="px-8 shadow-premium"
                    @click="pay()"
                    :disabled="total == 0"
                  >
                    <v-icon left>mdi-credit-card-check-outline</v-icon>
                    Efectuar Pago
                  </v-btn>
                </div>
              </div>
            </v-expand-transition>

            <!-- Placeholder if no course selected or no payments -->
            <div v-if="curso && (!pagos.items || pagos.items.length === 0)" class="text-center pa-10 bg-light-gradient rounded-xl mt-4">
              <v-icon size="64" color="grey lighten-2">mdi-check-circle-outline</v-icon>
              <h3 class="text-h6 grey--text text--darken-1 mt-4">Al día</h3>
              <p class="text-body-2 grey--text">No tienes aranceles pendientes para este curso.</p>
            </div>

          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>

    <!-- Mantenimiento -->
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper" v-else>
      <v-col cols="12" class="pa-0">
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)" v-if="user && user.IDStB">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Servicio en Mantenimiento</h1>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30">mdi-tools</v-icon>
          </div>
        </div>
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4 pa-6" elevation="10">
          <v-alert prominent type="error" class="rounded-xl mb-6">
            Servicio en mantenimiento, pronto estaremos en linea, Gracias
          </v-alert>
          <v-text-field
            v-model="isadmin"
            label="Enter password"
            outlined
            rounded
            dense
            type="password"
            @input="up"
          ></v-text-field>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "PaymentCurso",
  components: {
    CardIeaAppMain,
  },

  data: function() {
    return {
      title:"Efectuar pago",
      curso: null,
      cursos:[],
      pagos:[],
      total:0,
      items:[],
      urlPay : '',
      mantenimiento:false,
      isadmin:'',
      isSuscribedDA : false,
      isSuscribedMB:false
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  mounted() {
    this.getIsSuscribedToDA();

    this.$API
      .get({
        url: "alumno/cursos",
        data: {},
      })
      .then((res) => {
        this.cursos = res;
      })
      .catch((err) => {
        console.log(err);
    });
  },

  methods: {
    handleEventClick(clickInfo) {
      let datos = clickInfo.event.extendedProps
      if(datos.turno_id && !datos.block){
        this.dialog = true
        this.turno_id = datos.turno_id;
      }
    },
    up (){
      if (this.isadmin == 'adminadmin') {
        this.mantenimiento = false;
      }
    },

    getIsSuscribedToDA() {
      if(!this.user || !this.user.IDStB) return;
      this.$API
        .get({
          url: "mp-getsuscription-status/" + this.user.IDStB,
          data: {},
        })
        .then((res) => {
          this.isSuscribedDA = res.isSuscribedMP;
          this.isSuscribedMB=res.isSuscribedMB;
        })
        .catch((err) => {
          console.log(err);
      });
    },

    async loadData() {
      if(!this.curso || !this.curso.Curso) return;
      this.$API
        .get({
          url: "listado-pagos/" + this.curso.Curso,
          data: {},
        })
        .then((res) => {
          this.pagos = res;
          this.total = 0;
        })
        .catch((err) => {
          console.log(err);
      });
    },

    getTextColorClass(pagoData) {
      if(pagoData.block) return 'grey--text';
      if(pagoData.pagado) return 'success--text text--darken-2';
      return 'primary-text';
    },

    canPay(pagoData) {
      return (!pagoData.block && !pagoData.pagado) ? true : false;
    },
    
    changeTotal(pagoData, index) {
      pagoData.index = index;
      if(pagoData.check){
        this.total += parseFloat(pagoData.precioAPagar)
      }else{
        this.total -= parseFloat(pagoData.precioAPagar);
      }
      let selecteds = this.pagos.items.filter(d => {return d.check;})
      this.items = selecteds.map((value) => {return {id: value.IDStB, monto: value.precioAPagarDesc, index:value.index }})
    },

    async pay() {
      let dataSend = {
        curso  : this.curso.Curso,
        alumno : this.user.IDStB,
        items  : this.items,
        sede : this.curso.cruso_data.sede.razonSocial,
      };

      let url = "mobbex/generar-link-pago-materias";

      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          if(res.error){
            alert(res.error)
            return false
          }
          location.href = res.data.url
        });
    }
  }
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.payment-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }
.bg-transparent { background-color: transparent !important; }

.bg-warning-light { background-color: #fffbeb !important; }
.bg-success-light { background-color: #f0fdf4 !important; }

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.05); }

.shadow-premium {
  box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important;
}

.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
